import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import InsertCrossLinkIcon from "./icons/insert-cross-reference.svg";
import InsertReferenceCommand from "./insertreferencecommand";
import {
  addListToDropdown,
  createDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import {
  enableDisableKeywordOption,
  CkeditorConstants
} from "../../src/utils";

const {
  localStorageItem: { CURRENT_SITE_DATA },
} = CkeditorConstants;

export default class InsertLinkUI extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add("insertreference", new InsertReferenceCommand(editor));

    const crossLinkInsertOptions = CkeditorConstants.INSERT_CROSS_REF_OPTIONS;
    editor.ui.componentFactory.add("insertreference", (locale) => {
      let dropdownView = createDropdown(locale);
      const command = editor.commands.get("insertreference");
      dropdownView.bind("isEnabled").to(command);

      dropdownView.id = "insertreference"

      addListToDropdown(
        dropdownView,
        getDropdownOptionsDefinitions(crossLinkInsertOptions)
      );

      dropdownView.buttonView.set({
        icon: InsertCrossLinkIcon,
        tooltip: CkeditorConstants.tooltip.INSERT_CROSS_REFERENCE,
        class: "insertCrossLinkIcon"
      });

      dropdownView.on("change:isOpen", () => {
        const getListElement = (listElementId) => {
          return editor.ui.view.toolbar.items._items.find(f => f.id === "insertreference")
            .listView.items._items.find(f => f.children._items.find(i => i.id == listElementId))
            .children._items[0];
        }
        if (getSiteKeywordEnabled()) {
          const keywords = getListElement(crossLinkInsertOptions[3].id);
          const numberedCitation = getListElement(crossLinkInsertOptions[4].id);
          const unnumberedCitation = getListElement(crossLinkInsertOptions[5].id);
          keywords.isEnabled = numberedCitation.isEnabled = unnumberedCitation.isEnabled =  !enableDisableKeywordOption(editor);
        }
        const aparRferences = getListElement(crossLinkInsertOptions[0].id);
        const creditLists = getListElement(crossLinkInsertOptions[1].id);
        const footNotes = getListElement(crossLinkInsertOptions[2].id);

        aparRferences.isEnabled = false;
        footNotes.isEnabled = false;
        creditLists.isEnabled = false;

      });

      dropdownView.on("execute", (eventInfo) => {
        editor.execute("insertreference", eventInfo);
      });

      return dropdownView;
    });
  }
}

function getDropdownOptionsDefinitions(crossLinkInsertOptions) {
  const itemDefinitions = new Collection();
  for (const crossLinkInsertOption of crossLinkInsertOptions) {
    let definition = {
      type: "button",
      model: new Model({
        id: crossLinkInsertOption.id,
        label: crossLinkInsertOption.label,
        withText: true,
        tooltip: true,
        class: "insertreference",
      }),
    };
    crossLinkInsertOption.id !== 'keywords' ?
      itemDefinitions.add(definition) :
      (getSiteKeywordEnabled() ? itemDefinitions.add(definition) : null);
  }
  return itemDefinitions;
}

/**
 * Get current site details from localStorage get site specific config for keyword plugin
 * @returns { boolean }
 */
function getSiteKeywordEnabled() {
  const currentSiteData = JSON.parse(localStorage.getItem(CURRENT_SITE_DATA));
  return currentSiteData && currentSiteData.keyword && currentSiteData.keyword.enabled;
}